var appEmbeds = document.createElement("script");
appEmbeds.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.4/jquery.min.js");
document.body.appendChild(appEmbeds);
appEmbeds.addEventListener("load", () => {
  const shopDomain = window.Shopify?.shop;

  if (shopDomain) {
    console.log("Fetching data for domain:", shopDomain);

    $.get(`https://apps.qeapps.com/ecom_apps_n/production/quickview/fetch-record?shop=${shopDomain}`)
      .done((responseObj) => {
        // console.log("Response:", responseObj);

        var current_shop_id = $('.qe_qequickview_app_embed #shop_id').text();
        var current_domain = $('.qe_qequickview_app_embed #shop_domain').text();
        var current_shop = $('.qe_qequickview_app_embed #shop_url').text();
        var currency_symbol = $('.qe_qequickview_app_embed #currency_symbol').text();
        var currency_code = ' ' + $('.qe_qequickview_app_embed #currency_code').text();

        var button_text = responseObj.data.quickviewbutton_text_name;
        var button_icon_name = responseObj.data.quickview_icon_name;
        var button_background_color = responseObj.data.quickviewbutton_bg_color;
        var button_text_color = responseObj.data.quickviewbutton_text_color;
        var annoncement_title = responseObj.data.ab_text;
        var annoncement_text_color = responseObj.data.ab_text_text;
        var annoncement_background_color = responseObj.data.ab_text_bg;
        var popup_loader = responseObj.data.quickview_loader;
        var add_to_cart_color = responseObj.data.ab_button_text_color;
        var add_to_cart_background = responseObj.data.ab_button_bg_color;
        var show_price = responseObj.data.showprice_text;
        var show_vendor = responseObj.data.showvendor_text;
        var show_desc = responseObj.data.showdescription_text;
        var product_background_color = responseObj.data.popup_bg_color;
        var product_text_color = responseObj.data.popup_text_color;
        var collection_grid_class = responseObj.data.collection_grid_class || 'grid__item';
        var custom_css = responseObj.data.custom_css;
        var custom_js = responseObj.data.custom_js;

        setTimeout(function () {

          if (custom_css != null) {
            var cCss = document.createElement("style");
            cCss.type = "text/css";
            cCss.innerHTML = custom_css;
            $('body').append(cCss);
          }

          if (custom_js != null) {
            var cJs = document.createElement("script");
            cJs.type = "text/javascript";
            cJs.innerHTML = custom_js;
            $('body').append(cJs);
          }


          if ($('.quick-view-button').length > 0) { $('.quick-view-button').remove(); }

          console.log("collection_grid_class");
          console.log(collection_grid_class);

          var current_url = window.location.href;
          if (current_url.includes('products') == false) {
            $("." + collection_grid_class + " a").each(function (index) {
              var attr_h = '';
              var attr = $(this).attr('href');
              if (typeof attr !== 'undefined' && attr !== false) {
                if ($(this).attr('href').length > 2) {
                  var attr_h = $(this).attr('href');
                  var str1 = $(this).attr('href');
                  var str2 = 'products';
                  if (str1.indexOf(str2) != -1) {
                    var div_length = $(this).parents('li').find('.qecollection_grid').length;
                    var p_handle = attr_h.split('/').pop();
                   $(this)[0].insertAdjacentHTML('afterend', '<div class="quick-view-button disp" style="display:none"><a class="quick-view embed-view-href" style="display: block; background-color: ' + annoncement_background_color + '; color: ' + annoncement_text_color + '" data-handle="' + p_handle + '" href="javascript:void(0);"><i class="qetextname_embed '+button_icon_name+'" id="qetextname_embed" aria-hidden="true"></i> </a></div>');
                  }
                }
              }
            });
          }

          var quickviewbutton_text_name = button_text;
          var quickviewbutton_bg_color = button_background_color;
          var quickviewbutton_text_color = button_text_color;

          var addtocartbutton_bg_color = add_to_cart_background;
          var addtocartbutton_text_color = add_to_cart_color;
          var popup_bg_color = product_background_color;
          var popup_text_color = product_text_color;

          // var showprice_text = show_price  ? 'on' : '';
          // var showdescription_text = show_desc  ? 'on' : '';
          // var showvendor_text = show_vendor ? 'on' : '';
          var showprice_text = !show_price  ? 'on' : show_price;
          var showdescription_text = !show_desc  ? 'on' : show_desc;
          var showvendor_text = !show_vendor ? 'on' : show_vendor;
          
          var popup_window_width = 90;
          var popup_window_height = 90;
          var quickview_icon_name = button_icon_name;
          
          var quickview_loader = popup_loader;

          var ab_text = annoncement_title || '';
          var ab_text_bg = annoncement_background_color;
          var ab_text_text = annoncement_text_color;

          var ab_font_size = '15px';
          var ab_button_bg_color = annoncement_background_color;

          $('head').append('<link rel="stylesheet" href="https://apps.qeapps.com/ecom_apps_n/production/quickview/css/qequickview.css">');
          $('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">');

          $('.quick-view-button .quick-view').css('display', 'block').css('background-color', quickviewbutton_bg_color).css('color', quickviewbutton_text_color);
          $('.qetextname_embed').after(' <span class="quickview-embed-view button-text-name ">' + quickviewbutton_text_name + '</span>');

          $('body').attr('id', 'Qe-mySidenav');
          var mainDiv = '<div class="Qe_Drawer-view">' +
            '  <div class="js-menu">' +
            '     <div id="main-drawer" style="background-color:'+popup_bg_color+'" class="js-menu"></div>' +
            '  </div>' +
            '</div>';
          $('main').append(mainDiv);
        
          $(document).on("click", ".quick-view-button a", function () {
            $('.Qe_Drawer-view #main-drawer').addClass("drawer-loader");

            $("#Qe-mySidenav").addClass("Qe-mystyle");
            var clickedProductHandle = $(this).attr('data-handle');
            $('.Qe_Drawer-view #main-drawer').empty();
            if (ab_text != '') {
              $('#main-drawer').append("<div class='qe_annocement_bar ab_text hide-for-loader'><p>" + ab_text + "</p></div>");
            }
            if (ab_button_bg_color != "") {
              $('#main-drawer').append("<style>.qe_annocement_bar p{margin:0;background-color:" + ab_text_bg + " !important;font-size:" + ab_font_size + ";color:" + ab_text_text + " !important; text-align: center;letter-spacing: 0px;padding: 5px 0 ;}</style>");
            }
            $("#main-drawer").append("<style>.cart-alert-success{background-color: #d0f0b0; color: #000; padding: 5px; text-align: center;} .qe_product-discription_right p{color:" + popup_text_color + "} .drawer-loader{background-image: url('" + quickview_loader + "') !important; background-repeat: no-repeat !important; background-position: center center !important; } .hide-for-loader{ display:none !important;}</style>");


            clickedProductHandle = clickedProductHandle.split('?').shift();


            jQuery.getJSON(window.Shopify.routes.root + 'products/' + clickedProductHandle + '.js', function (product) {

              var productId = product.id;
              var productHandle = product.handle;
              var productTitle = (product.title != undefined) ? product.title : '';
              var productDescription = product.description ? product.description : '';


              if (productDescription.length > 100) {
               productDescription = productDescription.slice(0, 100) + "...";
               //productDescription = productDescription
              }

              // Check if full description should be shown
              var productDescriptionFull = showdescription_text === "on" ? product.description : "";
              var productDescriptionbtn = showdescription_text === "on" ? 'block' : 'none';
              var showMore = productDescription.length > 100? true:false;
              var productFeaturedImage = (product.featured_image) ? product.featured_image : '';
              var productType = product.type;
              var productVariants = product.variants;

              var productOptions = product.options;
              console.log("productVariants", productVariants);
              var firstAvailable = productVariants.find(function(product) {
                  return product.available === true;
              });
              console.log("firstAvailable", firstAvailable);
              

              if (showvendor_text == 'on') {
                var productVendor = "Vendor- " + product.vendor;
                var productVendorText = "block"
              } else {
                var productVendor = "";
                var productVendorText = "none"
              }
              var productTags = product.tags;
              
              const allImages =  product.images.map((image,index )=> `<div class="product-image img_list-dr_qe ${index == 0?`active`:``}" style="display:${index == 0?``:`none`};" image-index="${index}"> <img src="${image}"/></div>` ).join('')
              const hasMultipleImages = product.images.length > 1;
              const imageElement = `<div class="product-image-slider"current-slide="0">
              <button type="button"name="prev" disabled current-slide="0"    style="display: ${hasMultipleImages ? 'block' : 'none'};"  max-slide="${product.images.length}" class=" button-slider button-prev"> <span class="button-text label"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></span></button>
              <div class="product-image-main">${allImages? allImages: `<div class="product-image img_list-dr_qe active"><img src="${productFeaturedImage}"/></div>`}</div>
              <button type="button"name="next" current-slide="0"    style="display: ${hasMultipleImages ? 'block' : 'none'};"   max-slide="${product.images.length}" class=" button-slider button-next"> <span class="button-text label">
              <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg>
              </span></button>
              </div>`; 
              var drawerContent = `
              <div class="header-drower hide-for-loader" style="background-color:${popup_bg_color}">
                <h2>Choose Options</h2>
                <span class="js-menu__close">
                  <a href="javascript:void(0)" class="closebtn closeNav-drawer">×</a>
                </span>
              </div>
              <div class="detail-qe-drower-inner hide-for-loader" style="background-color:${popup_bg_color}" data-product-id="${productId}" data-product-handle="${productHandle}">
                <div class="product-details_dr-qe">
                  <div class="product-details__image_dr_qe">
                    ${imageElement}
                  </div>
                  <div class="qe_product-details_right">
                    <div class="product-details__title_qe" style="color:${popup_text_color}">${productTitle}</div>
                    <div class="product-details__subtitle_qe" style="color:${popup_text_color}"></div>
                    <div style="display:${productVendorText};color:${popup_text_color};">${productVendor}</div>
                    <div class="drbr-qe-right-price one" style="color:${popup_text_color}">
                      <s style="color:${popup_text_color}"></s>
                    </div>

                    <div class="qe_product-discription_right discription-full" style="color:${popup_text_color}; display:${productDescriptionbtn};">
                      ${productDescriptionFull}
                    </div>
                    <div class="view_full-details_right_qe-quickview discription-full-btn" style="display:${showMore?productDescriptionbtn:`none`}">
                      <a style="color:;font-size: 12px;border: 1px solid;padding: 2px 4px; cursor: pointer;">Show more</a>
                    </div>
                  </div>
                </div>
                <div class="variant-main-bg"></div>
                <div class="qe_btn-group">
                  <div class="hidden-perameters">
                    <input class="hidden-variant-id" type="hidden" name="id" value="" />
                    <input class="hidden-variant-qty" min="1" type="hidden" id="quantity" name="quantity" value="1"/>
                  </div>
                  <button ${!firstAvailable.available?'disabled':''} class="QeAddtocart-btn" style="background-color:${addtocartbutton_bg_color}; color:${addtocartbutton_text_color};"> ${!firstAvailable.available?'OUT OF STOCK':'ADD TO CART'} </button>
                  <a class="QeGOtocart-link" href="/cart" style="background-color:${addtocartbutton_bg_color}; color:${addtocartbutton_text_color};">GO TO CART</a>
                </div>
              </div>`;

              // Append to drawer
              $('.Qe_Drawer-view #main-drawer').append(drawerContent);

              var prodOptContent = '';
              if (product.options) {
                var productOptions = product.options;


                var productVariantsId = firstAvailable.id;
                $('.hidden-perameters .hidden-variant-id').val(productVariantsId);

                var productVariantsTitle = firstAvailable.title;
                if (productVariantsTitle != 'Default Title') {
                  $('.product-details__subtitle_qe').text(productVariantsTitle.toUpperCase());
                }

                var cartCurrencyFront = currency_symbol || 'Rs.';
                var cartCurrencyBack = currency_code;

                var optionComparePrice = firstAvailable.compare_at_price; 
                var optionPrice = firstAvailable.price;

                if (showprice_text == "on") {
 
                  if (!optionComparePrice || optionComparePrice <= optionPrice) {
                    $('.drbr-qe-right-price').html(cartCurrencyFront + (optionPrice / 100).toFixed(2) + cartCurrencyBack);
                  } else {
                    $('.drbr-qe-right-price').html('<s style="color:' + popup_text_color + '">' + cartCurrencyFront + (optionComparePrice / 100).toFixed(2) + cartCurrencyBack + '</s> ' + cartCurrencyFront + (optionPrice / 100).toFixed(2) + cartCurrencyBack + ' <div class="sale-box">Sale</div>');
                  }
                }

                
                $.each(productOptions, function (key, obj) {
                  var optionName = obj.name;
                  var optionValues = obj.values;

                  var optionValue = firstAvailable.options[obj.position - 1];

                  if (optionName.toLowerCase() != 'title') {
                    prodOptContent += '<div class="size-variant-bg">';
                    prodOptContent += '   <h4 class="color-variant-title">' + optionName + ': <span></span></h4>';
                    optionValues.forEach(function (sub_value, sub_key) {
                      var checkedTrue = (sub_key == 0) ? 'checked' : '';
                      if(sub_value==optionValue){
                        checkedTrue = 'checked';
                      }
                      prodOptContent += '   <div class="radio-inner-box">';
                      prodOptContent += '      <label class="' + sub_value + '-bg" for="' + optionName.toLowerCase() + '-' + sub_value + '">';
                      prodOptContent += '         <input class="swatch-option-value"  type="radio" id="' + optionName.toLowerCase() + '-' + sub_value + '" name="' + optionName.toLowerCase() + '" value="' + sub_value + '" data-product-id="' + productId + '" data-product-handle="' + productHandle + '" ' + checkedTrue + '>';
                      prodOptContent += '         <span style="background-color:' + addtocartbutton_text_color + '; color:' + addtocartbutton_bg_color + '; ">' + sub_value + '</span>';
                      prodOptContent += '      </label>';
                      prodOptContent += '   </div>';
                    });
                    prodOptContent += '</div>';

                  }
                });
              }
              $('.variant-main-bg').append(prodOptContent);
              $(document).find('.discription-full table').wrap('<div class="responsive-table-div" style="overflow-x: auto; max-width: 65%;"></div>');

              setTimeout(function () {
                $('.Qe_Drawer-view #main-drawer').removeClass("drawer-loader");
                $('.Qe_Drawer-view .header-drower, .Qe_Drawer-view .detail-qe-drower-inner, .qe_annocement_bar').removeClass("hide-for-loader");
              }, 1000);
            });
          });

          $(document).on("click", ".closeNav-drawer", function () {
            $("#Qe-mySidenav").removeClass("Qe-mystyle");
            $('.Qe_Drawer-view #main-drawer .img_list-dr_qe img').attr('src', '');
            $('.Qe_Drawer-view #main-drawer .qe_product-details_right .product-details__title_qe').text('');
          });

          $(document).on('click', 'input[type=radio][class="swatch-option-value"]', function () {
            var productId = $(this).attr('data-product-id');
            var productHandle = $(this).attr('data-product-handle');
            var radioValue = $('.variant-main-bg input[type=radio][class="swatch-option-value"]:checked').map(function (i, el) {
              return $(el).val();
            }).get();
            var optionJoin = radioValue.join(" / ");
            if (radioValue.length > 0) {
              jQuery.getJSON(window.Shopify.routes.root + 'products/' + productHandle + '.js', function (product) {
                var productVariants = product.variants;
                productVariants.forEach(function (sub_value, sub_key) {
                  var optionId = sub_value.id;
                  var optionAvailable = sub_value.available;
                  var optionTitle = sub_value.title;
                  var optionPrice = sub_value.price;
                  var optionComparePrice = sub_value.compare_at_price;
                  var optionImage = (sub_value.featured_image) ? sub_value.featured_image.src : '';

                  //var currency = "{{ cart.currency.symbol }}";
                  var cartCurrencyFront = currency_symbol || 'Rs.';
                  var cartCurrencyBack = currency_code;
                  if (optionTitle == optionJoin) {
                    $('.hidden-perameters .hidden-variant-id').val(optionId);
                    $('.product-details__subtitle_qe').text(optionTitle.toUpperCase());
                    if (optionImage) {
                      $('.img_list-dr_qe img').attr('src', optionImage);
                    }

                     

                    if (!optionComparePrice || optionComparePrice <= optionPrice) {
                      
                      $('.drbr-qe-right-price').html(cartCurrencyFront + (optionPrice / 100).toFixed(2) + cartCurrencyBack);
                    } else {
                      
                      $('.drbr-qe-right-price').html('<s style="color:' + popup_text_color + '">' + cartCurrencyFront + (optionComparePrice / 100).toFixed(2) + cartCurrencyBack + '</s> ' + cartCurrencyFront + (optionPrice / 100).toFixed(2) + cartCurrencyBack + ' <div class="sale-box">Sale</div>');
                    }

                    if (optionAvailable == false || optionAvailable == 'false') {
                      $('.qe_btn-group .QeAddtocart-btn').attr('disabled', '').text('Out of stock!');
                    } else {
                      $('.qe_btn-group .QeAddtocart-btn').removeAttr('disabled').text('ADD TO CART');
                    }
                  }
                });
              });
            }
          });

          $(document).on('click', '.qe_btn-group .QeAddtocart-btn', function () {
            var optionId = $('.hidden-perameters .hidden-variant-id').val();
            var optionQty = $('.hidden-perameters .hidden-variant-qty').val();

            let formData = {
              'items': [{
                'id': optionId,
                'quantity': optionQty
              }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
              .then(response => {
                if (response.status == 200) {
                  $('.header-drower .js-menu__close a.closeNav-drawer').addClass('add-to-cart-clicked');
                  $('.qe_btn-group .hidden-perameters').after('<div class="cart-alert-success"><strong>Success!</strong> Product added to cart. </div>');
                  setTimeout(function () {
                    $('.qe_btn-group .cart-alert-success').remove();
                  }, 3000);
                  return response.json();
                }
              })
              .catch((error) => { });
          });

          $(document).on('click', '.discription-full-btn a', function (e) {
            e.stopPropagation();
            var text = $('.discription-full');
            var btn = $('.discription-full-btn a');

            if (btn.hasClass('less')) {
              btn.removeClass('less');
              btn.addClass('more');
              btn.text('Show more');
              text.removeClass('more-product-desc');
              text.addClass('less-product-desc');
            } else {
              btn.addClass('less');
              btn.removeClass('more');
              btn.text('Show less');
              text.removeClass('less-product-desc');
              text.addClass('more-product-desc');
            }
          });
         //  image slider
          $(document).on('click', '.product-image-slider .button-slider', function () {
            const btnType = $(this).attr('name');
            const $slider = $(this).closest('.product-image-slider');
            let current_slide = parseInt($slider.attr('current-slide'));
            const $slides = $slider.find('.img_list-dr_qe');
            const $prevBtn = $slider.find('.button-slider[name="prev"]');
            const $nextBtn = $slider.find('.button-slider[name="next"]');
        
            if (btnType === 'next' && current_slide < $slides.length - 1) {
                const $currentSlide = $slides.eq(current_slide);
                const $nextSlide = $slides.eq(current_slide + 1);
                $currentSlide.removeClass('active').fadeOut('slow');
                $nextSlide.addClass('active').fadeIn('slow');
                current_slide++;
        
                // Update buttons
                $slider.attr('current-slide', current_slide);
                if (current_slide === $slides.length - 1) {
                    $nextBtn.attr('disabled',true);
                }
                $prevBtn.removeAttr('disabled');
            }
        
            if (btnType === 'prev' && current_slide > 0) {
                const $currentSlide = $slides.eq(current_slide);
                const $prevSlide = $slides.eq(current_slide - 1);
                $currentSlide.removeClass('active').fadeOut('slow');
                $prevSlide.addClass('active').fadeIn('slow');
                current_slide--;
        
                // Update buttons
                $slider.attr('current-slide', current_slide);
                if (current_slide === 0) {
                    $prevBtn.attr('disabled',true);
                }
                $nextBtn.removeAttr('disabled');
            }
        });
          setTimeout(function () {
             $('.quick-view-button').show();
          },800)
        }, 1500);


      })
  }
});